import { authToken } from '@td/api';

export const COMPLETE_REQUEST = 'COMPLETE_REQUEST';
export const PICK_INCENTIVE_COST  = 'PICK_INCENTIVE_COST';
export const CLEAR_INCENTIVE_COST = 'CLEAR_INCENTIVE_COST';
export const APPLY_FILTER     = 'APPLY_FILTER';
export const FETCH_INCENTIVE_COSTS  = 'FETCH_INCENTIVE_COSTS';
export const FETCH_INCENTIVE_COSTS_START = 'FETCH_INCENTIVE_COSTS_START';
export const FINISH_FETCH_INCENTIVE_COSTS_PROVIDERS = 'FINISH_FETCH_INCENTIVE_COSTS_PROVIDERS';
export const START_FETCH_INCENTIVE_COSTS_PROVIDERS = 'START_FETCH_INCENTIVE_COSTS_PROVIDERS';

export const START_TOGGLE_PROVIDER_IN_INCENTIVE = 'START_TOGGLE_PROVIDER_IN_INCENTIVE';
export const FINISH_TOGGLE_PROVIDER_IN_INCENTIVE = 'FINISH_TOGGLE_PROVIDER_IN_INCENTIVE';

export const START_ADD_PROVIDER_TO_INCENTIVE = 'START_ADD_PROVIDER_TO_INCENTIVE';
export const ADD_PROVIDER_TO_INCENTIVE = 'ADD_PROVIDER_TO_INCENTIVE';
export const ADD_PROVIDER_TO_INCENTIVE_SUCCESS = 'ADD_PROVIDER_TO_INCENTIVE_SUCCESS';

export const START_REMOVE_PROVIDER_FROM_INCENTIVE = 'START_REMOVE_PROVIDER_FROM_INCENTIVE';
export const REMOVE_PROVIDER_FROM_INCENTIVE = 'REMOVE_PROVIDER_FROM_INCENTIVE';
export const REMOVE_PROVIDER_FROM_INCENTIVE_SUCCESS = 'REMOVE_PROVIDER_FROM_INCENTIVE_SUCCESS';

export const MODIFY_INCENTIVE = 'MODIFY_INCENTIVE';
export const START_ADD_MANY_INCENTIVES_REQUEST = 'START_ADD_MANY_INCENTIVES_REQUEST';
export const START_ADD_MANY_INCENTIVES = 'START_ADD_MANY_INCENTIVES';
export const FINISH_ADD_MANY_INCENTIVES = 'FINISH_ADD_MANY_INCENTIVES';
export const ADD_MANY_INCENTIVES = 'ADD_MANY_INCENTIVES';
export const COMPLETE_ADD_MANY_INCENTIVES = 'COMPLETE_ADD_MANY_INCENTIVES';
export const FLASH_MESSAGE = 'FLASH_MESSAGE';

export const DELETE_INCENTIVE = 'DELETE_INCENTIVE';
export const FINISH_DELETE_INCENTIVE = 'FINISH_DELETE_INCENTIVE';

export function finishDeleteIncentive() {
  return {
    type: FINISH_DELETE_INCENTIVE
  };
}
export function deleteIncentive(incentiveCostId) {
  const url = `/v4/provider_incentive_costs/${incentiveCostId}`;
  return {
    type:    DELETE_INCENTIVE,
    payload: { url, token: authToken.get() }
  };
}

export function flashMessage(message) {
  return {
    type: FLASH_MESSAGE,
    message
  };
}
export function modifyIncentive(incentive) {
  return {
    type: MODIFY_INCENTIVE,
    incentive
  };
}

export function finishAddManyIncentives() {
  return {
    type: FINISH_ADD_MANY_INCENTIVES
  };
}

export function startToggleProviderInIncentive() {
  return {
    type: START_TOGGLE_PROVIDER_IN_INCENTIVE
  };
}
export function finishToggleProviderInIncentive() {
  return {
    type: FINISH_TOGGLE_PROVIDER_IN_INCENTIVE
  };
}

export function startAddManyIncentives() {
  return {
    type: START_ADD_MANY_INCENTIVES
  };
}
export function startAddManyIncentivesRequest() {
  return {
    type: START_ADD_MANY_INCENTIVES_REQUEST
  };
}
export function completeAddManyIncentives(response) {
  return {
    type: COMPLETE_ADD_MANY_INCENTIVES,
    response
  };
}

export function addManyIncentives(incentives) {
  const url = '/v4/provider_incentive_costs';
  const incentivePayloads = incentives.map(incentive => ({
    provider_incentive_cost: {
      service_specialty_code:      incentive.selectedSpecialtyCode,
      state_code:                   incentive.stateCode,
      amount:                       incentive.amount,
      max_number_providers:         incentive.maxNumberOfProviders,
      start_date:                   incentive.startDateTime,
      end_date:                     incentive.endDateTime
    }
  }));
  const token = authToken.get();
  return {
    type:     ADD_MANY_INCENTIVES,
    payloads: [
      { url, token, params: { provider_incentive_costs: incentivePayloads } }
    ]
  };
}

export function addProviderToIncentive(incentiveCostId, providerId) {
  const url = `/v4/provider_incentive_costs/${incentiveCostId}/providers`;
  const params = { provider_id: providerId };
  return {
    type:    ADD_PROVIDER_TO_INCENTIVE,
    payload: { url, params, token: authToken.get() },
    incentiveCostId,
    providerId
  };
}

export function removeProviderFromIncentive(incentiveCostId, providerId, deletionReason) {
  const url = `/v4/provider_incentive_costs/${incentiveCostId}/providers/${providerId}?notes=${deletionReason}`;
  const params = {reason_text: deletionReason};
  return {
    type:    REMOVE_PROVIDER_FROM_INCENTIVE,
    payload: { url, params, token: authToken.get() },
    incentiveCostId,
    providerId
  };
}

export function removeProviderFromIncentiveSuccess(response, incentiveCostId, providerId) {
  return { type: REMOVE_PROVIDER_FROM_INCENTIVE_SUCCESS, response, incentiveCostId, providerId };
}
export function addProviderToIncentiveSuccess(response, incentiveCostId, providerId) {
  return { type: ADD_PROVIDER_TO_INCENTIVE_SUCCESS, response, incentiveCostId, providerId };
}

export function finishFetchIncentiveCostsProviders(response) {
  return { type: FINISH_FETCH_INCENTIVE_COSTS_PROVIDERS, response };
}

export function startFetchIncentiveCostsProviders() {
  return { type: START_FETCH_INCENTIVE_COSTS_PROVIDERS };
}

export function completeRequest(response) {
  return { type: COMPLETE_REQUEST, response };
}
export function clearIncentiveCost() {
  return { type: CLEAR_INCENTIVE_COST };
}
export function pickIncentiveCost(incentiveCost) {
  return { type: PICK_INCENTIVE_COST, incentiveCost };
}

export function applySearchFilter(filter) {
  return { type: APPLY_FILTER, filter };
}

export const fetchIncentiveCostsStart = () => ({
  type: FETCH_INCENTIVE_COSTS_START
});

export function startRemoveProviderFromIncentive() {
  return { type: START_REMOVE_PROVIDER_FROM_INCENTIVE };
}
export function startAddProviderToIncentive() {
  return { type: START_ADD_PROVIDER_TO_INCENTIVE };
}

export const fetchIncentiveCosts = filters => {
  const endpoint = '/v4/provider_incentive_costs';
  const params   = filters;

  return {
    type:    FETCH_INCENTIVE_COSTS,
    payload: { url: endpoint, params, token: authToken.get() }
  };
};
